import { useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'

export const useGetFormattedDuration = () => {
	const { t } = useLingui()

	return useMemo(() => {
		return {
			P0D: t`Maintenant`,
			PT1H: t`Dans 1 heure`,
			PT2H: t`Dans 2 heures`,
			PT12H: t`Dans 12 heures`,
			P1D: t`Dans 1 jour`,
			P2D: t`Dans 2 jours`,
			P7D: t`Dans 1 semaine`,
			P14D: t`Dans 2 semaines`,
			P1M: t`Dans 1 mois`,
			P2M: t`Dans 2 mois`,
			P3M: t`Dans 3 mois`,
			P6M: t`Dans 6 mois`,
		}
	}, [t])
}
